const atomic = require('../../../git_modules/@tomandco/atomic/config/color');

/**
 * Not all colors are used to generate atomic classes
 *
 * Use named colors in SCSS files by `get` function
 * @example
 * ```css
 *   .class {
 *     color: get('namedColor.abbey');
 *   }
 * ```
 */
const namedColor = {
    dune: '#211F1E', //1
    flint: '#6B6461', // 11
    zorba: '#9E9794', // 12
    alizarinCrimson: '#E8291C', // 2
    japaneseLaurel: '#008000', // 3
    alto: '#D9D9D9', // 5
    wildSand: '#F5F5F5', // 51
    sunglow: '#F04F22', // 6 Make sure its not overrided by pgr
    salomie: '#F58D70', // 61
    cork: '#26337A', // 62
    arrowtown: '#6374CF', // 63
    yellow: '#FECE34', // 7
    bronze: '#CCAA68', // 71
    midGrey: '#6B6461', // 72
    accountDarkGrey: '#353231', // 73
    accountBlack: '#0E0E0E', // 74
    nobel: '#B3B3B3' // 4
};
exports.namedColor = namedColor;

/**
 * Thouse colors are used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .col-1 { color: #454647; }
 * ```
 */
const color = [
    { key: '1', value: namedColor.dune, title: 'Off black', group: 'Primary' },
    { key: '11', value: namedColor.flint, title: 'Dark grey', group: 'Primary' },
    { key: '12', value: namedColor.zorba, title: 'Light grey', group: 'Primary' },
    { key: '2', value: namedColor.alizarinCrimson, title: 'Error red', group: 'Status' },
    { key: '3', value: namedColor.japaneseLaurel, title: 'Success green', group: 'Status' },
    { key: '4', value: namedColor.nobel, title: 'Dark background', group: 'Backgrounds' },
    { key: '5', value: namedColor.alto, title: 'Background', group: 'Backgrounds' },
    { key: '51', value: namedColor.wildSand, title: 'Light background', group: 'Backgrounds' },
    { key: '6', value: namedColor.sunglow, title: 'Orange colour', group: 'Brand' },
    { key: '61', value: namedColor.salomie, title: 'Orange tint', group: 'Brand' },
    { key: '62', value: namedColor.cork, title: 'Blue', group: 'Brand' },
    { key: '63', value: namedColor.arrowtown, title: 'Blue Tint', group: 'Brand' },
    { key: '7', value: namedColor.yellow, title: 'Yellow', group: 'Pro Account Colours' },
    { key: '71', value: namedColor.bronze, title: 'Bronze', group: 'Pro Account Colours' },
    { key: '72', value: namedColor.midGrey, title: 'Mid grey', group: 'Pro Account Colours' },
    { key: '73', value: namedColor.accountDarkGrey, title: 'Account dark grey', group: 'Pro Account Colours' },
    { key: '74', value: namedColor.accountBlack, title: 'Account black', group: 'Pro Account Coloursa' },
    { key: 'w', value: 'white', title: 'White', group: 'System' }
];
exports.color = color;
